export const determineFormDirtyFields = (
  initialValues: Record<string, any>,
  values: Record<string, any>
) => {
  return Object.keys(initialValues).filter((key) => {
    const initialValue = initialValues[key as keyof typeof initialValues]
      ?.toString()
      ?.trim();
    const currentValue = values[key as keyof typeof values]?.toString()?.trim();

    return initialValue !== currentValue;
  });
};
